export const ExpStarIcon = () => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5934 4.35473L6.7557 6.00965L6.74951 5.99992V0C6.8857 0 7.0188 0.074634 7.08999 0.220657L8.65002 3.53375C8.70574 3.65057 8.81098 3.7317 8.93479 3.75117L12.4232 4.28334C12.4882 4.29307 12.547 4.31903 12.5934 4.35473Z"
        fill="url(#paint0_linear_9024_43907)"
      />
      <path
        d="M10.1112 7.54103C10.0214 7.63189 9.98116 7.76493 9.99973 7.89149L10.5971 11.5356C10.6157 11.6426 10.5909 11.7432 10.5383 11.8211L6.75586 6.00942L12.5936 4.35449C12.7731 4.49078 12.8134 4.77958 12.6338 4.9613L10.1112 7.54103Z"
        fill="url(#paint1_linear_9024_43907)"
      />
      <path
        d="M10.5387 11.8214C10.4396 11.9804 10.2323 12.0551 10.0465 11.9545L6.92649 10.2347C6.81506 10.173 6.68506 10.173 6.57363 10.2347L3.45358 11.9545C3.26786 12.0551 3.06048 11.9804 2.96143 11.8214L6.75006 6V6.00973H6.75625L10.5387 11.8214Z"
        fill="url(#paint2_linear_9024_43907)"
      />
      <path
        d="M6.74982 6L2.96119 11.8214C2.90857 11.7436 2.88381 11.643 2.90238 11.5359L3.49668 7.8918C3.51834 7.76525 3.47811 7.63221 3.38834 7.54135L0.865684 4.96161C0.683062 4.77665 0.729491 4.47812 0.915209 4.35156L6.74982 6Z"
        fill="url(#paint3_linear_9024_43907)"
      />
      <path
        d="M6.74967 0V5.99991L0.915039 4.35147C0.961468 4.31578 1.01409 4.29307 1.07599 4.28333L4.56439 3.75116C4.68511 3.73169 4.79344 3.65057 4.84916 3.53375L6.40919 0.220657C6.48038 0.0746339 6.61348 0 6.74967 0Z"
        fill="url(#paint4_linear_9024_43907)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9024_43907"
          x1="9.67147"
          y1="0"
          x2="12.9322"
          y2="6.47057"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1B61E" />
          <stop offset="1" stopColor="#EED491" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9024_43907"
          x1="9.75294"
          y1="4.35449"
          x2="9.75294"
          y2="11.8211"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B214" />
          <stop offset="1" stopColor="#EED491" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9024_43907"
          x1="6.72078"
          y1="10.7125"
          x2="3.7359"
          y2="7.39256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B10F" />
          <stop offset="1" stopColor="#EED491" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9024_43907"
          x1="3.74991"
          y1="4.35156"
          x2="3.74991"
          y2="11.8214"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B214" />
          <stop offset="1" stopColor="#EED491" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_9024_43907"
          x1="3.83235"
          y1="-1.53388e-07"
          x2="-1.21074"
          y2="4.86804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2BD35" />
          <stop offset="0.0001" stopColor="#F0B214" />
          <stop offset="1" stopColor="#EED491" />
        </linearGradient>
      </defs>
    </svg>
  );
};
